import React from 'react';

export const CountryFlag = ({ countryCode, countryName, className = 'inline-block h-5 w-8 rounded-sm object-cover', alt }) => {
  // console.log("Country code for flag:", countryName);
  let code = typeof countryCode === 'string' ? countryCode.trim().toLowerCase() : '';
  
  if (countryName && countryName.trim().toLowerCase().includes("usa")) {
    code = "us";
  }
  
  if (!code || !/^[a-z]{2}$/.test(code)) {
    return <span className={`inline-flex items-center justify-center ${className}`}>🌐</span>;
  }

  const src = `https://flagcdn.com/48x36/${code}.png`;

  const fallbackImage = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='24'%3E%3Crect width='40' height='24' fill='%23e5e7eb'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-size='10' fill='%236b7280'%3E?%3C/text%3E%3C/svg%3E";

  return (
    <img
      src={src}
      alt={alt || `${countryCode.toUpperCase()} flag`}
      className={className}
      onError={(event) => {
        event.currentTarget.onerror = null;
        event.currentTarget.src = fallbackImage;
      }}
    />
  );
};
